import { render, staticRenderFns } from "./IconographyTypoUseColors.vue?vue&type=template&id=0f71bbce"
import script from "./IconographyTypoUseColors.vue?vue&type=script&lang=ts"
export * from "./IconographyTypoUseColors.vue?vue&type=script&lang=ts"
import style0 from "./IconographyTypoUseColors.vue?vue&type=style&index=0&id=0f71bbce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports